"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardSaveArea = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCardSaveArea = require("./PropertyCardSaveArea.styles");
/**
 * A container for the save button in a `PropertyCard`.
 *
 * @since 8.67.0
 */
var PropertyCardSaveArea = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PropertyCardSaveArea.StyledPropertyCardSaveArea, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.PropertyCardSaveArea = PropertyCardSaveArea;
PropertyCardSaveArea.displayName = 'PropertyCard.SaveArea';